var Q = require('q');

var BaseStore = require('./BaseStore');
var CardValidator = require('../validators/CardValidator');
var Invocation = require('../api/Invocation');
var InvoiceStore = require('./Invoice/InvoiceStore');
var InvoiceActions = require('../actions/InvoiceActions');
var PaymentConstants = require('../constants/Payment');
var UserStore = require('./UserStore');

var PaymentStore = new BaseStore({
    defaultData: null
});
PaymentStore.amount = 0;
PaymentStore.card = {};
PaymentStore.cardErrors = [];
PaymentStore.selectedInvoices = [];
PaymentStore.token = null;
PaymentStore.tokenErrors = [];

PaymentStore.clear = function () {
    this.amount = 0;
    this.card = {};
    this.cardErrors = [];
    this.token = null;
    this.tokenErrors = {};

    BaseStore.prototype.clear.call(this);
};

PaymentStore.getPayment = function () {
    return this._data;
};

PaymentStore.setPayment = function (payment) {
    this.clear();
    this._data = payment;
};

PaymentStore._handlePaymentFailure = function (token, card, err) {
    this.cardErrors = [];

    if (err.res) {
        if (err.res.body.violations && err.res.body.violations.length) {
            this.cardErrors = err.res.body.violations;
        }
        if (err.res.body.payment && !err.res.body.payment.success) {
            this.cardErrors.push({ property_path: token ? 'card.cvn' : 'card.number', message: 'The payment was not successful. Please check your card details and try again.' });
        }
    }
    if (!this.cardErrors.length) {
        this.cardErrors.push({ property_path: token ? 'card.cvn' : 'card.number', message: 'An error has occurred. Please check your card details and try again.' });
    }

    if (this.cardErrors.length) {
        err.handled = true;
    }

    throw err;
};

PaymentStore.register(PaymentConstants.NEW, function () {
    this.clear();
    // Do not put in clear(). Required after a clear is called.
    this.selectedInvoices = [];

    return true;
});

PaymentStore.register(PaymentConstants.PAY, function () {
    if (!this.token && !this.card) {
        throw new Error("Unable to handle payment when this.token and card are both not supplied");
    }
    if (!this.selectedInvoices && !this.selectedInvoices.length) {
        throw new Error("Unable to pay when no invoices are set");
    }

    const { save, ...card } = this.card || {};
    if (this.token) {
        this.cardErrors = CardValidator.validateCvn(card);
    } else {
        this.cardErrors = CardValidator.validateCard(card);

        card.expiry_month = card.expiryMonth;
        card.expiry_year = card.expiryYear;
        delete card.expiryMonth;
        delete card.expiryYear;
    }

    if (
        (this.cardErrors && this.cardErrors.length) ||
        (this.token && this.tokenErrors[this.token.id] && this.tokenErrors[this.token.id].length)
    ) {
        this.emitChange();
        return;
    }

    this._loading = true;

    var promise = this.token ?
        Invocation.billing.payFromToken(this.token, this.amount, card.cvn, save) :
        Invocation.billing.payFromCard(card, this.amount, UserStore.getClientId(), save);

    promise = promise
        .catch((err) => this._handlePaymentFailure(this.token, card, err))
        .then(({ body }) => {
            this.setPayment(body.payment);
            return body.payment;
        });

    promise = promise
        .then(payment =>
            Q.all(this.selectedInvoices.map(invoice =>
                Invocation.invoice.assignPayment(invoice, payment.id, invoice.total - invoice.paid)
            ))
        )
        .then(() => {
            InvoiceStore.clear();
            InvoiceActions.getInvoices();
            this.selectedInvoices = [];
        });

    promise
        .then(() => this.finish())
        .catch((err) => this.finishWithErrors(err))
        .done();

    return true;
});

PaymentStore.register(PaymentConstants.SELECT_INVOICE, function (payload) {
    var { invoice, selected } = payload.action;

    var index = this.selectedInvoices.findIndex(function (search) {
        return search.id == invoice.id;
    });

    if (selected && index == -1) {
        this.selectedInvoices.push(invoice);
    } else if (index > -1) {
        this.selectedInvoices.splice(index, 1);
    }

    this.amount = this.selectedInvoices.map(function (invoice) {
        return invoice.total - invoice.paid;
    }).reduce(function (a, b) { return a + b; }, 0);

    return true;
});

PaymentStore.register(PaymentConstants.SELECT_TOKEN, function (payload) {
    this.token = payload.action.token;

    return true;
});

PaymentStore.register(PaymentConstants.UPDATE_CARD, function (payload) {
    this.card = payload.action.card;

    return true;
});

module.exports = PaymentStore;



// WEBPACK FOOTER //
// ./app/stores/PaymentStore.js